module.exports = __webpack_public_path__ + "site/img/129.4a6dd542.jpg";